var _g, _path, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFragranceBottle = function SvgFragranceBottle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 36 40",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6c6c6c",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.5 3.6 4.2-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 7.80002 4.2 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9004 5.70001h4.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.28169.5c4.32676 0 9.61501 3.33333 11.71831 5-1.8028 2-6.3099 6-10.8169 6-7.21127 0-6.30986-11-.90141-11z",
    fill: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5996 5.70001h4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.375 23.575h24.45v8.425c0 4.2112-3.4138 7.625-7.625 7.625h-9.2c-4.2112 0-7.625-3.4138-7.625-7.625z",
    fill: "#6c6c6c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.9004 21.1h1.4v15.4h-1.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.9004 14.8h1.4v8.4h-1.4z",
    fill: "#6c6c6c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.8008 2.90002h5.6v5.6h-5.6z",
    fill: "#6c6c6c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.8008 9.20001h5.6v2.1h-5.6z",
    fill: "#6c6c6c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2996,
    cy: 4.99999,
    fill: "#fff",
    r: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.375 22.825h24.45v-2.825c0-4.2112-3.4138-7.625-7.625-7.625h-9.2c-4.2112 0-7.625 3.4138-7.625 7.625z",
    stroke: "#6c6c6c",
    strokeWidth: 0.75
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFragranceBottle);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjQwIiB2aWV3Qm94PSIwIDAgMzYgNDAiIHdpZHRoPSIzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiM2YzZjNmMiIHN0cm9rZS13aWR0aD0iLjc1Ij48cGF0aCBkPSJtMjcuNSAzLjYgNC4yLTIuMSIvPjxwYXRoIGQ9Im0yNy41IDcuODAwMDIgNC4yIDIuMSIvPjxwYXRoIGQ9Im0yOC45MDA0IDUuNzAwMDFoNC4yIi8+PHBhdGggZD0ibTUuMjgxNjkuNWM0LjMyNjc2IDAgOS42MTUwMSAzLjMzMzMzIDExLjcxODMxIDUtMS44MDI4IDItNi4zMDk5IDYtMTAuODE2OSA2LTcuMjExMjcgMC02LjMwOTg2LTExLS45MDE0MS0xMXoiIGZpbGw9IiM2YzZjNmMiLz48cGF0aCBkPSJtMTUuNTk5NiA1LjcwMDAxaDQuOSIvPjxwYXRoIGQ9Im0xMC4zNzUgMjMuNTc1aDI0LjQ1djguNDI1YzAgNC4yMTEyLTMuNDEzOCA3LjYyNS03LjYyNSA3LjYyNWgtOS4yYy00LjIxMTIgMC03LjYyNS0zLjQxMzgtNy42MjUtNy42MjV6IiBmaWxsPSIjNmM2YzZjIi8+PC9nPjxwYXRoIGQ9Im0yMS45MDA0IDIxLjFoMS40djE1LjRoLTEuNHoiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJtMjEuOTAwNCAxNC44aDEuNHY4LjRoLTEuNHoiIGZpbGw9IiM2YzZjNmMiLz48cGF0aCBkPSJtMTkuODAwOCAyLjkwMDAyaDUuNnY1LjZoLTUuNnoiIGZpbGw9IiM2YzZjNmMiLz48cGF0aCBkPSJtMTkuODAwOCA5LjIwMDAxaDUuNnYyLjFoLTUuNnoiIGZpbGw9IiM2YzZjNmMiLz48Y2lyY2xlIGN4PSIyMy4yOTk2IiBjeT0iNC45OTk5OSIgZmlsbD0iI2ZmZiIgcj0iLjciLz48cGF0aCBkPSJtMTAuMzc1IDIyLjgyNWgyNC40NXYtMi44MjVjMC00LjIxMTItMy40MTM4LTcuNjI1LTcuNjI1LTcuNjI1aC05LjJjLTQuMjExMiAwLTcuNjI1IDMuNDEzOC03LjYyNSA3LjYyNXoiIHN0cm9rZT0iIzZjNmM2YyIgc3Ryb2tlLXdpZHRoPSIuNzUiLz48L3N2Zz4=";